import { createRoot, hydrateRoot } from "react-dom/client";
import AppEntry from "./AppEntry";
import { prechargerLangue } from "./contexts/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import { initializeTrustedTypes } from "./lib/trustedTypes";
import "./index.css";

initializeTrustedTypes();

if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    const recoveryKey = `vite-preload-retry:${window.location.pathname}`;
    if (window.sessionStorage.getItem(recoveryKey)) return;

    window.sessionStorage.setItem(recoveryKey, "1");
    const retryUrl = new URL(window.location.href);
    retryUrl.searchParams.set("asset_retry", Date.now().toString());
    window.location.replace(retryUrl.toString());
  });
}

const container = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <AppEntry />
  </HelmetProvider>
);

// Pages pré-rendues au build (HTML complet pour les moteurs de recherche et l'affichage
// avant le JavaScript) : React reprend le HTML existant au lieu de le recréer.
if (container.dataset.prerendered === "1" && container.firstElementChild) {
  // Accueils /en, /de, /nl : la langue est chargée avant la reprise, comme au pré-rendu.
  const langue = window.location.pathname.match(/^\/(en|de|nl)\/?$/)?.[1] as "en" | "de" | "nl" | undefined;
  void (langue ? prechargerLangue(langue) : Promise.resolve()).then(() => {
    // Balises <title>/<meta>/<link> écrites au pré-rendu : React pose celles de la page (pas de doublons).
    document.head.querySelectorAll("title[data-prerendu], meta[data-prerendu], link[data-prerendu]").forEach((el) => el.remove());
    hydrateRoot(container, app);
  });
} else {
  createRoot(container).render(app);
}
